export const validateStringField = (field, name, message) =>{
    if (field === undefined || field === null || field.trim() === '') {
        throw message ? message : `Please provide ${name}`;
    }
};